module.exports = __webpack_public_path__ + "img/radiometer-logo2.b86d16db.png";